import React from 'react';
import AlgoliaSearch from '../../ui/AlgoliaSearch/AlgoliaSearch';
import Select from '@homeaway/react-form-select';
import ent from 'ent';

const generateItems = (filters) => {
    let items = filters.map(({value, label}) => {
        return {
            value,
            label: ent.decode(label),
        };
    });
    return items;
};

const OpeningsJumbotron = ({
    categoryFilters,
    locationFilters,
    filters,
    handleSelect,
    handleClear,
    algolia,
    history,
}) => {
    const categoryItems = generateItems(categoryFilters);
    categoryItems.unshift({
        value: '',
        label: 'All Categories',
    });
    const locationItems = generateItems(locationFilters);
    locationItems.unshift({
        value: '',
        label: 'All Locations',
    });
    return (
        <React.Fragment>
            <form>
                <div className="form-combined">
                    <div className="form-combined-row">
                        <Select
                            items={categoryItems}
                            name="category"
                            label={'Select category'}
                            onChange={(e) => {
                                handleSelect(e, 'category');
                            }}
                            value={filters.category}
                        />
                        <Select
                            items={locationItems}
                            name="location"
                            label={'Select location'}
                            onChange={(e) => {
                                handleSelect(e, 'location');
                            }}
                            value={filters.location}
                        />
                    </div>
                </div>
                <AlgoliaSearch
                    {...algolia}
                    history={history}
                    filters={filters}
                />
                <button
                    className="btn btn-default btn-inverse btn-sm"
                    onClick={handleClear}
                >
                    {'Clear search'}
                </button>
            </form>
        </React.Fragment>
    );
};

export default OpeningsJumbotron;
